import {
  IApiConfig,
  useApiClient as useApiClientGeneric,
} from '@4r/module-common-mf-app';

function modifyApiEndpoint(url: string): string {
  return `${url.replace('/services-api', '') || ''}/mf-time-attendance-api`;
}

function useApiClient<T>(
  Factory: new (config: IApiConfig, baseUrl: string) => T,
) {
  return useApiClientGeneric<T>(Factory, modifyApiEndpoint);
}

export default useApiClient;
